import { useState } from "react";
import {
  Alert,
  Card,
  Snackbar,
  Grid,
  TextField
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { t } from "i18next";
import api from "../../../helpers/api/LoginApi";
import ApiUrls from "../../../helpers/urls/ApiUrls";
import AppConfig from "../../../helpers/constants/AppConfig";
import MDBox from "components/MDs/MDBox";
import MDTypography from "components/MDs/MDTypography";
import BasicLayout from "components/LayoutContainers/BasicLayout";
import bgImage from "assets/images/sign-in-bg.jpg";
import { Link } from "react-router-dom";
import RouteUrls from "../../../helpers/urls/RouteUrls";

function ForgotPassword() {
  const [formData, setFormData] = useState({
    username: '',
  });
  const { username } = formData;
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snack, setSnack] = useState({message: '', severity: 'success'});

  const handleChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  const checkInputs = () => {
    let temp_errors = {};

    if (username === "") {
      temp_errors.username = t("message.auth_required", { item: t("user.user_id") });
    }

    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      forgotPassword();
    }
  }

  const forgotPassword = () => {
    setLoading(true);
    let postFormData = new FormData();
    postFormData.append('username', username);

    api.post(ApiUrls.auth.forgot_password, postFormData)
      .then((response) => {
        setLoading(false);
        setAlert("ایمیل تغییر رمز عبور به آدرس الکترونیکی شما ارسال شد.");
      })
      .catch((error) => {
        setLoading(false);
        showSnackbar("خطا در انجام عملیات!", "error");
      });
  }

  const showSnackbar = (message, severity) => {
    setSnack({message: message, severity: severity});
    setSnackbarOpen(true);
  }

  return (
    <BasicLayout image={bgImage} isAuth>
      <Card className="sign-in">
        <MDBox
          variant="gradient"
          bgColor={AppConfig.color}
          borderRadius="lg"
          coloredShadow={AppConfig.color}
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h6" fontWeight="medium" color="white">
            {t("auth.forgot_password")}
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox>
            {alert ?
              <Grid item md={12} mb={3}>
                <Alert severity="success" className="alert-smaller">{alert}</Alert>
              </Grid>
              :
              null
            }

            <MDBox mb={2}>
              <TextField id="username" label={t("user.user_id")} variant="outlined" fullWidth
                         value={username} autoFocus className="ltr-textfield" error={!!errors?.username} helperText={errors?.username}
                         onKeyPress={(e) => e.key === 'Enter' && checkInputs()}
                         onChange={(e) => handleChange(e.target.value, "username")} />
            </MDBox>

            <MDBox mt={4} mb={1}>
              <LoadingButton
                id="sign-in-button"
                color={AppConfig.color}
                loading={loading}
                variant="contained"
                fullWidth
                onClick={checkInputs}
              >
                {t("auth.send_email")}
              </LoadingButton>
            </MDBox>

            <MDBox mt={3} mb={1} className="d-flex justify-content-center">
              <Link to={RouteUrls.auth.login} className="fp-link-style">
                {t("auth.login")}
              </Link>
            </MDBox>

          </MDBox>
        </MDBox>
      </Card>

      <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
        <Alert severity={snack.severity} variant="filled">
          {snack.message}
        </Alert>
      </Snackbar>
    </BasicLayout>
  );
}

export default ForgotPassword;
